import React from 'react';
import moment from 'moment';
import {getFormatedPhoneNumber} from '../utils';
import classNames from 'classnames';

const ShowCard = ({t1, t2, t3, t4, desc}) => (
  <div>
    <div className="mt-[7px] flex gap-3 font-bold">
      <div>{t1}</div>
      <div className="h-[27px] w-[1px] bg-[grey]"> </div>
      <div>{t2}</div>
    </div>
    <div className="my-[7px] flex gap-3 font-bold">
      <div>{t3}</div>
      <div className="h-[27px] w-[1px] bg-[grey]"> </div>
      <div>{t4}</div>
    </div>
    <div dangerouslySetInnerHTML={{__html: desc || ''}}></div>
  </div>
);

const ResumePreview = ({resumeDetails}) => {
  const {
    firstName = null,
    lastName = null,
    email = null,
    phone = null,

    country = null,
    state = null,

    resume,
  } = resumeDetails;

  const {
    order: resumeFieldOrder,

    education = [],
    experience = [],
    skills = [],
    certificates = [],
    languages = [],

    summary = null,
  } = resume;

  const handleComponents = () => {
    const handleComp = [];

    resumeFieldOrder.forEach((field) => {
      if (field !== 'basic' && field !== 'summary') {
        handleComp.push(chooseComponent(field));
      }
    });

    return handleComp;
  };

  const chooseComponent = (compType) => {
    switch (compType) {
      case 'experience':
        return (
          <>
            <hr className="mt-[27px]" />
            <div className="mt-[27px] mb-[17px] text-2xl font-bold">
              Experience
            </div>
            <div className="flex flex-col gap-[10px]">
              {experience.map(
                ({
                  _id,
                  companyName = '-',
                  city = null,
                  country = null,
                  designation = '',
                  startDate,
                  endDate,
                  currentlyEmployed,
                  responsibilities = '',
                }) => (
                  <ShowCard
                    key={_id}
                    t1={companyName}
                    t2={[city, country].filter(Boolean).join(', ')}
                    t3={designation}
                    t4={`${moment(startDate).format('MMM YY')} - ${
                      currentlyEmployed
                        ? 'Present'
                        : moment(endDate).format('MMM YY')
                    }`}
                    desc={responsibilities}
                  />
                ),
              )}
            </div>
          </>
        );
      case 'education':
        return (
          <>
            <hr className="mt-[27px]" />
            <div className="mt-[27px] mb-[17px] text-2xl font-bold">
              Education
            </div>
            <div className="flex flex-col gap-[10px]">
              {education.map(
                ({
                  _id,
                  college = '-',
                  city = null,
                  country = null,
                  course = '',
                  courseEndDate,
                  achievements = '',
                }) => (
                  <ShowCard
                    key={_id}
                    t1={college}
                    t2={[city, country].filter(Boolean).join(', ')}
                    t3={course}
                    t4={moment(courseEndDate).format('MMM YY')}
                    desc={achievements}
                  />
                ),
              )}
            </div>
          </>
        );
      case 'skills':
        return (
          <>
            <hr className="mt-[27px]" />
            <div className="mt-[27px] mb-[17px] text-2xl font-bold">Skills</div>
            {skills.map(({skillId: {name}}) => name).join(', ')}
          </>
        );
      case 'languages':
        return (
          <>
            <hr className="mt-[27px]" />
            <div className="mt-[27px] mb-[17px] text-2xl font-bold">
              Languages
            </div>
            {languages.join(', ')}
          </>
        );
      case 'certificate':
        return (
          <>
            <hr className="mt-[27px]" />
            <div className="mt-[27px] mb-[17px] text-2xl font-bold">
              Certificate & Awards
            </div>
            <ul>
              {certificates.map((certificate) => (
                <li key={certificate}>{certificate}</li>
              ))}
            </ul>
          </>
        );
      default:
        return null;
    }
  };

  const headerClass = 'py-[2px] pr-3 border-r border-[gray] last:border-none';

  return (
    <div className="p-3 font-DMSans text-xl" id="view-resume">
      <div className="text-4xl font-bold">
        {firstName} {lastName[0]}.
      </div>
      <div className="mt-4 flex gap-3">
        <button
          className={classNames('text-primary-main', headerClass)}
          onClick={() => email && window.open(`mailto:${email}`)}
        >
          {email}
        </button>

        <button
          className={classNames('text-primary-main', headerClass)}
          onClick={() => phone && window.open(`tel:+${phone}`)}
        >
          {getFormatedPhoneNumber(phone)}
        </button>

        <div className={headerClass}>{state}</div>
        <div className={headerClass}>{country}</div>
      </div>

      <hr className="mt-[27px]" />

      {summary && (
        <>
          <div className="mt-[27px] mb-[17px] text-2xl font-bold">Summary</div>
          <div dangerouslySetInnerHTML={{__html: summary}}></div>
        </>
      )}

      {handleComponents()}
    </div>
  );
};

export default ResumePreview;
